import React from 'react';
import { Radio, RadioChangeEvent } from 'antd';

import { IRadioGroupProps } from './RadioGroup.types';

import './RadioGroup.styles.scss';

const RadioGroup = <T,>({ children, onChange, className = '', ...props }: IRadioGroupProps<T>) => {
  const handleChange = (e: RadioChangeEvent) => {
    onChange(e.target.value);
  };

  return (
    <Radio.Group onChange={handleChange} optionType="button" className={`np-radio-group ${className}`} {...props}>
      {children}
    </Radio.Group>
  );
};

export default RadioGroup;
